export default {"src":"/_next/static/media/AbsolutelyFree.156a1f80.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};